interface OrderInfoCardProps {
  inOrderNumber: string;
  setInOrderNumber: (value: string) => void;
  remark: string;
  setRemark: (value: string) => void;
}
const OrderInfoCard: React.FC<OrderInfoCardProps> = (props) => {
  const { inOrderNumber, setInOrderNumber, remark, setRemark } = props;
  const handleInOrderNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInOrderNumber(e.target.value);
  };
  const handleRemark = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setRemark(e.target.value);
  };
  return (
    <div className="">
      <div className="block2">
        <label className="primaryLabel">采购单号PO. No. (可选)</label>
      </div>
      <div className="gap8">
        <input className='input'
        maxLength={25}
        placeholder="请填写贵司内部采购单号"
         value={inOrderNumber} onChange={handleInOrderNumber}></input>
      </div>
      <div className="block3">
        <label className="primaryLabel">订单备注 (可选)</label>
      </div>
      <div className="gap8">
        <textarea className='input'
        style={{resize: 'vertical'}}
        rows={5}
        maxLength={200}
        placeholder="如果您在此栏留有特别备注说明，我们将在48小时内对其进行评估，并做相应订单处理。因此，请仅在有必要的情况下在此栏输入信息。如果您对 产品或者交付日期 有特殊要求，请在此备注说明。"
        value={remark} onChange={handleRemark}></textarea>
      </div>
    </div>
  );
};

export default OrderInfoCard;
